import { useCallback, useEffect, useMemo, useState } from 'react'

type GalleryImage = {
  url: string
  caption: string
}

type GallerySection = {
  title: string
  description?: string
  fit?: 'cover' | 'contain'
  images: GalleryImage[]
}

const gallerySections: GallerySection[] = [
  {
    title: "Doolan Larson Exterior: Then & NOW",
    images: [
      {
        url: "/content/images/Doolan_Larson_haight_facade_large_Crop2k.jpg",
        caption: "Doolan-Larson Haight St. Facade"
      },
      {
        url: "/content/images/Doolan_Larson_Exterior_Clock_IMG_7531_Crop2k.jpg",
        caption: "View of the iconic Doolan-Larson 4:20 Clock"
      },
      {
        url: "/content/images/Norm.H-A.BW_.jpeg",
        caption: "Norm Larson at the Doolan Larson House in 2016."
      },
      {
        url: "/content/images/shutterstock_editorial_17089m-color-adjusted_Crop2k.jpg",
        caption: "Haight-Ashbury in 1967 Photo ©Peter Larsen/REX (17089m)"
      },
      {
        url: "/content/images/Doolan_Larson_Exterior_Ariel_AAB-8876-t_Crop2k.jpg",
        caption: "View of the Haight-Ashbury intersection in the 1960s"
      }
    ]
  },
  {
    title: "Interior Photos",
    images: [
      {
        url: "/content/images/Doolan_Larson_Scott-Hahn%C2%A92018_557-Ashbury-31_Crop2k.jpg",
        caption: "Foyer Facing North"
      },
      {
        url: "/content/images/Doolan_Larson_Scott-Hahn%C2%A92018_557-Ashbury-60_Crop2k.jpg",
        caption: "Dining Room on Upper Floor"
      },
      {
        url: "/content/images/Doolan_Larson_Scott-Hahn%C2%A92018_557-Ashbury-33_Crop2k-scaled.jpg",
        caption: "Foyer with Stairs to Upper Floor"
      },
      {
        url: "/content/images/Doolan_Larson_Scott-Hahn%C2%A92018_557-Ashbury-28_Crop2k.jpg",
        caption: "View thru House on the Lower Floor"
      },
      {
        url: "/content/images/Christopher_Michel_2016_Doolan-Larson_House_12-2-16214763haight_Crop2k.jpg",
        caption: "Formal Parlor with Fireplace"
      },
      {
        url: "/content/images/Christopher_Michel_2016_Doolan-Larson_House_12-2-16214872haight_Crop2k.jpg",
        caption: "Bedroom with Exposed Plaster Walls"
      },
      {
        url: "/content/images/Christopher_Michel_2016_Doolan-Larson_House_12-2-16214988haight_Crop2k.jpg",
        caption: "Formal Parlor"
      },
      {
        url: "/content/images/Doolan_Larson_Scott-Hahn%C2%A92018_557-Ashbury-7_Crop2k.jpg",
        caption: "Lower Floor Kitchen with Exposed Plaster Walls"
      },
      {
        url: "/content/images/Doolan_Larson_Scott-Hahn%C2%A92018_557-Ashbury-2_Crop2k.jpg",
        caption: "Dining Room on Lower Floor"
      },
      {
        url: "/content/images/Doolan_Larson_Scott-Hahn%C2%A92018_557-Ashbury-12_Crop2k-scaled.jpg",
        caption: "Pantry"
      },
      {
        url: "/content/images/Doolan_Larson_Scott-Hahn%C2%A92018_557-Ashbury-64_Crop2k.jpg",
        caption: "The Attic"
      },
      {
        url: "/content/images/Christopher_Michel_2016_Doolan-Larson_House_12-2-16214988haight_Crop2k.jpg",
        caption: "View East from Family Parlor to Formal Parlor"
      }
    ]
  },
  {
    title: "Building Diagrams",
    description: "The diagrams below illustrate the maximum allowable building envelope and use of space within the existing building. This does not represent a required architectural or interior plan.",
    fit: "contain",
    images: [
      {
        url: "/content/images/2020-5-22_Doolan-Larson_Drawings_Page_1-scaled.jpg",
        caption: "Ground Floor Plan (Program Study)"
      },
      {
        url: "/content/images/2020-5-22_Doolan-Larson_Drawings_Page_2-scaled.jpg",
        caption: "Second Floor Plan (Program Study)"
      },
      {
        url: "/content/images/2020-5-22_Doolan-Larson_Drawings_Page_3-scaled.jpg",
        caption: "Third Floor Plan (Program Study)"
      },
      {
        url: "/content/images/2020-5-22_Doolan-Larson_Drawings_Page_4-scaled.jpg",
        caption: "Attic Plan (Program Study)"
      },
      {
        url: "/content/images/2020-5-22_Doolan-Larson_Drawings_Page_5-scaled.jpg",
        caption: "Basement Plan (Program Study)"
      },
      {
        url: "/content/images/2020-5-22_Doolan-Larson_Drawings_Page_6-scaled.jpg",
        caption: "Longitudinal Section (Program Study)"
      },
      {
        url: "/content/images/2020-5-22_Doolan-Larson_Drawings_Page_7-1024x663.jpg",
        caption: "Perspective from Haight Street. (Program Study)"
      },
      {
        url: "/content/images/2020-5-22_Doolan-Larson_Drawings_Page_8-scaled.jpg",
        caption: "Perspective from Haight Street (Program Study)"
      }
    ]
  },
  {
    title: "Recent Events",
    images: [
      {
        url: "/content/images/Eyezen-Presents-OUT-of-Site_-Haight-Ashbury-7_16_21_IMG_7573_Crop2k.jpg",
        caption: "Eyezen Presents OUT of Site at Haight-Ashbury"
      },
      {
        url: "/content/images/Eyezen-Presents-OUT-of-Site_-Haight-Ashbury-7_16_21_IMG_7582_Crop2k.jpg",
        caption: "Eyezen Presents OUT of Site at Haight-Ashbury"
      },
      {
        url: "/content/images/Jenna_Harkins_Jimmie-Fails_Photo_Exhibition_Distractions-Clothing_000020120002_Crop2k.jpg",
        caption: "Artist in Residence Jimmie Fails"
      },
      {
        url: "/content/images/Chibueze-Crouch_Residency_20220713_111608_Crop2k.jpg",
        caption: "Artist in Residence Chibueze Crouch in Office"
      }
    ]
  },
  {
    title: "Norm Larson",
    images: [
      {
        url: "/content/images/Christopher-Michel-2016-Selects-Portraits-of-Norm-Larson_12-2-16214699haight_Crop2k.jpg",
        caption: "Norm Larson in 2016"
      },
      {
        url: "/content/images/NormLarson_2017_215_Crop2k-1.jpg",
        caption: "Norm Larson in 2016"
      },
      {
        url: "/content/images/NormLarson_August1956_Crop2k.jpg",
        caption: "Norm Larson in 1956"
      }
    ]
  }
]

const Gallery = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)

  const allImages = useMemo(
    () => gallerySections.flatMap((section) => section.images),
    []
  )

  const active = activeIndex === null ? null : allImages[activeIndex]

  const close = useCallback(() => setActiveIndex(null), [])
  const showPrev = useCallback(() => {
    setActiveIndex((current) => {
      if (current === null) return current
      return (current + allImages.length - 1) % allImages.length
    })
  }, [allImages.length])
  const showNext = useCallback(() => {
    setActiveIndex((current) => {
      if (current === null) return current
      return (current + 1) % allImages.length
    })
  }, [allImages.length])

  useEffect(() => {
    document.title = "Gallery - Haight & Ashbury"
  }, [])

  useEffect(() => {
    if (activeIndex === null) return

    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') close()
      if (event.key === 'ArrowLeft') showPrev()
      if (event.key === 'ArrowRight') showNext()
    }

    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKey)
    }
  }, [activeIndex, close, showPrev, showNext])

  let runningIndex = 0

  return (
    <div>
      <section className="page-hero">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="mb-8">Gallery</h1>
            <p className="text-[20px] leading-[26px] tracking-[-0.02em] text-haight-gold">
              Explore the historic Doolan-Larson House &amp; Storefronts through photographs and architectural drawings. Select any image to view it larger.
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="space-y-16 md:space-y-20">
            {gallerySections.map((section) => (
              <div key={section.title} className="space-y-6">
                <div className="max-w-3xl mx-auto text-center space-y-3">
                  <h2 className="text-haight-navy">{section.title}</h2>
                  {section.description && (
                    <p className="text-base text-gray-600">{section.description}</p>
                  )}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10">
                  {section.images.map((image) => {
                    const index = runningIndex
                    runningIndex += 1
                    return (
                      <figure key={`${image.url}-${index}`} className="min-w-0">
                        <button
                          type="button"
                          onClick={() => setActiveIndex(index)}
                          className="block w-full text-left group focus:outline-none focus-visible:ring-2 focus-visible:ring-haight-navy focus-visible:ring-offset-2"
                          aria-label={`View larger: ${image.caption}`}
                        >
                          <span className="block overflow-hidden bg-neutral-100">
                            <img
                              src={image.url}
                              alt=""
                              className={`w-full h-52 sm:h-56 ${
                                section.fit === 'contain' ? 'object-contain p-2' : 'object-cover'
                              } transition-opacity duration-200 group-hover:opacity-90`}
                              loading="lazy"
                              decoding="async"
                            />
                          </span>
                        </button>
                        <figcaption className="mt-2 text-[12px] sm:text-[13px] leading-snug tracking-normal text-gray-500 font-normal">
                          {image.caption}
                        </figcaption>
                      </figure>
                    )
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding pt-0 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center space-y-4 text-base text-gray-600">
            <p>
              A special thank you to the Larson Family and all of the SF Heritage Supporters who contributed these photos for the website.
            </p>
            <p>
              And a very special thank you to Norm Larson for his extraordinary stewardship of the Doolan-Larson buildings. For decades, Norm cared for this landmark not only as a historic structure but also as a vibrant home for artists, dreamers, and seekers. His generous gift of the property to San Francisco Heritage in 2017 made this project possible.
            </p>
          </div>
        </div>
      </section>

      {active && activeIndex !== null && (
        <div
          className="fixed inset-0 z-[80] bg-black/90 flex flex-col"
          role="dialog"
          aria-modal="true"
          aria-label={active.caption}
          onClick={close}
        >
          <div className="flex items-center justify-between px-4 py-3 text-white shrink-0">
            <p className="text-[13px] text-white/70">
              {activeIndex + 1} / {allImages.length}
            </p>
            <button
              type="button"
              onClick={close}
              className="min-h-11 min-w-11 inline-flex items-center justify-center text-white text-2xl leading-none"
              aria-label="Close larger image"
            >
              ×
            </button>
          </div>

          <div className="relative flex-1 min-h-0 flex items-center justify-center px-4 pb-4">
            <button
              type="button"
              onClick={(event) => { event.stopPropagation(); showPrev() }}
              className="hidden sm:inline-flex absolute left-2 md:left-4 top-1/2 -translate-y-1/2 min-h-11 min-w-11 items-center justify-center text-white text-3xl bg-black/40 hover:bg-black/70"
              aria-label="Previous image"
            >
              ‹
            </button>
            <img
              src={active.url}
              alt={active.caption}
              className="max-h-full max-w-full object-contain"
              onClick={(event) => event.stopPropagation()}
            />
            <button
              type="button"
              onClick={(event) => { event.stopPropagation(); showNext() }}
              className="hidden sm:inline-flex absolute right-2 md:right-4 top-1/2 -translate-y-1/2 min-h-11 min-w-11 items-center justify-center text-white text-3xl bg-black/40 hover:bg-black/70"
              aria-label="Next image"
            >
              ›
            </button>
          </div>

          <div
            className="px-4 pb-[max(1rem,env(safe-area-inset-bottom))] text-center shrink-0"
            onClick={(event) => event.stopPropagation()}
          >
            <p className="text-[13px] leading-snug text-white/85 max-w-3xl mx-auto">{active.caption}</p>
            <div className="sm:hidden flex justify-center gap-6 mt-3">
              <button type="button" onClick={(e) => { e.stopPropagation(); showPrev() }} className="min-h-11 px-4 text-white" aria-label="Previous image">‹ Prev</button>
              <button type="button" onClick={(e) => { e.stopPropagation(); showNext() }} className="min-h-11 px-4 text-white" aria-label="Next image">Next ›</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Gallery
